"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoList = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const globals_1 = require("../common/util/constants/globals");
exports.LogoList = styled_1.default.div `
  display: flex;

  flex-flow: ${({ isVertical }) => (isVertical ? 'column wrap' : 'row wrap')};

  align-items: center;

  img {
    max-height: 50px;
    max-width: ${globals_1.PROVIDER_LOGO_MAX_WIDTH_PX_COUNT}px;
    width: auto;
    ${({ isVertical, theme }) => isVertical && `padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')({ theme })}`}
    ${({ isVertical, theme }) => !isVertical && `padding-right: ${(0, ui_theme_1.fromTheme)('spacing_small')({ theme })}`}
  }
`;
//# sourceMappingURL=ProviderLogos.styles.js.map